const darkPalette = {
  text: {
    primary: "#FFFFFF",
    secondary: "#636669",
    disabled: "#636669",
  },
  safeGreen: {
    main: "#12FF80",
    light: "#1E2A23",
  },
  primary: {
    dark: "#0cb259",
    main: "#12FF80",
    light: "#A1A3A7",
  },
  background: {
    default: "#121312",
    paper: "#1C1C1C",
    main: "#121312",
  },
  secondary: {
    main: "#FFFFFF",
    light: "#12FF80",
  },
  border: {
    main: "#636669",
    light: "#303033",
    background: "#121312",
  },
}

export default darkPalette
